import { motion } from 'framer-motion';

const enter = { initial: { opacity: 0, y: 14 }, animate: { opacity: 1, y: 0 } };

export default function HeroSection() {
  return (
    <header id="hero" className="hero">
      <div className="container hero__grid">
        <motion.div initial="initial" animate="animate" transition={{ staggerChildren: 0.09, duration: 0.45, ease: 'easeOut' }}>
          <motion.p className="eyebrow" variants={enter}>Rafael Perales / Austin, TX</motion.p>
          <motion.h1 className="hero__title" variants={enter}>Hi, I'm Rafa. Scroll down to see how I got here.</motion.h1>
          <motion.p className="hero__lead" variants={enter}>
            TL;DR: I'm an electrical and computer engineering student at UT Austin focused on software engineering and data science.
            I've interned at Capital One twice, working with underwriting model teams across both Auto Finance and Card.
          </motion.p>
          <motion.div className="hero__actions" variants={enter}>
            <button className="button button--primary" onClick={() => document.querySelector('#experience')?.scrollIntoView({ behavior: 'smooth' })}>Explore experience</button>
            <a className="button button--secondary" href="https://docs.google.com/document/d/1xbEcM3RewD0nwPSV-XJOu06UBAGxmEKQS2x7u8Kd4b0/edit?usp=sharing" target="_blank" rel="noreferrer">View resume</a>
          </motion.div>
          <motion.div className="hero__meta" variants={enter}>
            <a href="mailto:rafaperales1229@gmail.com">rafaperales1229@gmail.com</a>
            <span>•</span>
            <span>ECE + Data Science</span>
          </motion.div>
        </motion.div>
        <motion.figure className="hero__portrait" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.28, duration: 0.55, ease: 'easeOut' }}>
          <img className="hero__image" src="/Images/IMG_3878.jpeg" alt="Rafael Perales" />
        </motion.figure>
      </div>
    </header>
  );
}
